import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppLoaderService } from './app-loader/app-loader.service';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsZipService {
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private loader: AppLoaderService
  ) {}

  downloadZip(urls: string[], attachmentName: any): void {
    const zip = new JSZip();
    const folder = zip.folder(`${attachmentName}.zip`);

    const fetchFilePromises = urls.map(url => {
      this.loader.start();
      const fileName = url.substring(url.lastIndexOf('/') + 1);
      return this.http.get(url, { responseType: 'blob' }).toPromise()
        .then(blob => {
          folder?.file(fileName, blob);
        }).catch(error => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: error.message || 'Error downloading file',
          });
          // console.error('Error downloading:', url, error);
        });
    });

    Promise.all(fetchFilePromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then(content => {
        this.loader.close();
        this.messageService.add({
          severity: 'success',
          summary: 'Success Message',
          detail: `Attachments downloaded successfully`,
        });
        saveAs(content, `${attachmentName}.zip`);
      });
    });
  }
}
